import store from '@/store/index'
import router from "@/router";
import vueCookies from 'vue-cookies'
import {
    getToken,
    appQuietLoginout,
    getNativeInfo
} from "@/utils/native.js";
// 获取最新用户信息
export function getUserInfo() {
    store.dispatch("userInfo", true);
}
// 保存用户令牌
export function setToken(token, openid) {
    store.state.isLogin = !!token
    store.state.h5authorization = token
    if (token) {
        // 获取用户信息
        getUserInfo();
    }
    if (store.state.isApp) {
        vueCookies.set('zzbAppCosWPAH5authorization', token, '1h')
    } else {
        vueCookies.set('zzbCosWPAH5authorization', token, '1h')
        vueCookies.set('zzbCosWPAOpenid', openid)
    }
}
// 检查Cookies
export function checkCookies() {
    // 获取令牌
    const token = vueCookies.get('zzbCosWPAH5authorization')
    // console.log('checkCookies', token)
    // 获取用户openid
    store.state.openid = vueCookies.get('zzbCosWPAOpenid')
    if (token) {
        setToken(token)
    }
}
// 判断是否微信环境
export function checkWeiXin() {
    store.state.isWeiXin = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
    // //console.log('isWeiXin', store.state.isWeiXin)
}

// 八保舟自动登录
export function autoLogin() {
    console.log('autoLogin')
    // 开发环境自动登录
    if (store.state.isDev) {
        // 获取令牌
        const token = vueCookies.get('zzbAppCosWPAH5authorization')
        // console.log('checkCookies', token)
        if (token) {
            setToken(token)
        } else {
            router.push({
                path: "/UserLogin"
            });
        }
    } else {
        // app中用户始终登录
        store.state.isLogin = true;
        // 获取用户登录token
        getToken().then(res => {
            if (res) {
                setToken(res);
                getNativeInfo().then(res => {
                    // console.log('getNativeInfo')
                    // console.log(res)
                    const data = JSON.parse(res);
                    // 检查是否可以切换到商城
                    store.state.isGoAms = data.authorities.includes('ams')
                })
            } else {
                appQuietLoginout();
            }
        });
    }

    // 50分后重新获取token避免过期
    setTimeout(() => {
        // console.log('autoLoginSetTimeout')
        autoLogin();
    }, 1000 * 60 * 50)
}